"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(inputObject) {
  var keyOperation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultKeyOperation;
  return Object.keys(inputObject).reduce(function (result, key) {
    result[keyOperation(key)] = inputObject[key];
    return result;
  }, {});
};

exports.default = _default;

var defaultKeyOperation = function defaultKeyOperation(keyVal) {
  return keyVal;
};